import { render } from "./MappaturaPiatti.vue?vue&type=template&id=9184bd86&scoped=true"
import script from "./MappaturaPiatti.vue?vue&type=script&lang=js"
export * from "./MappaturaPiatti.vue?vue&type=script&lang=js"

import "./MappaturaPiatti.vue?vue&type=style&index=0&id=9184bd86&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9184bd86"]])

export default __exports__